/* ============================================================
   Kong — Home Bestseller 3D
   Reveal on scroll (IntersectionObserver) + model-viewer load
   + tilt sutil desktop. Vanilla JS, sin librerías externas.
   Cada sección .hb3d se inicializa de forma independiente.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function initSection(sec) {
    if (!sec || sec.dataset.hb3dInit === '1') return;
    sec.dataset.hb3dInit = '1';

    var anim = sec.getAttribute('data-anim') === 'true' && !reduce;

    /* ── Visor 3D (model-viewer) ── */
    var viewer = sec.querySelector('[data-hb3d-viewer]');
    var mv     = sec.querySelector('[data-hb3d-mv]');
    var hint   = sec.querySelector('[data-hb3d-hint]');
    if (mv) {
      var mvSrc = mv.getAttribute('data-mv-src');
      var injectMV = function () {
        if (!mvSrc || window.customElements.get('model-viewer') || document.querySelector('script[data-kong-mv]')) return;
        var sc = document.createElement('script'); sc.type = 'module'; sc.src = mvSrc; sc.setAttribute('data-kong-mv', ''); document.head.appendChild(sc);
      };
      if ('IntersectionObserver' in window) {
        var mvIO = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { injectMV(); mvIO.disconnect(); } }, { rootMargin: '150px 0px' });
        mvIO.observe(sec);
      } else { injectMV(); }
      if (reduce) mv.removeAttribute('auto-rotate');
      if (viewer) viewer.classList.add('is-loading');
      mv.addEventListener('load', function () {
        sec.classList.add('hb3d--ready');
        if (viewer) viewer.classList.remove('is-loading');
      });
      mv.addEventListener('error', function () {
        sec.classList.remove('hb3d--ready');          // se queda la imagen estática (fallback)
        if (viewer) viewer.classList.remove('is-loading');
      });
      mv.addEventListener('camera-change', function (e) {
        if (e.detail && e.detail.source === 'user-interaction' && hint) hint.style.opacity = '0';
      });
    }

    /* ── Reveal on scroll ── */
    if (anim && 'IntersectionObserver' in window) {
      sec.classList.add('hb3d--js');                  // activa el estado oculto inicial
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { sec.classList.add('hb3d--inview'); io.unobserve(sec); }
        });
      }, { threshold: 0.18 });
      io.observe(sec);
    }
    /* sin anim o sin IO: el contenido queda visible por defecto (no se añade hb3d--js) */

    /* ── Tilt sutil (máx 5deg) solo desktop con puntero fino ── */
    var tilt  = sec.querySelector('[data-hb3d-tilt]');
    var stage = sec.querySelector('.hb3d__stage');
    var fine  = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if (tilt && stage && fine && !reduce) {
      var raf = null, rx = 0, ry = 0;
      function apply() {
        raf = null;
        tilt.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      }
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width  - 0.5;
        var py = (e.clientY - r.top)  / r.height - 0.5;
        ry =  px * 5;     // rotateY
        rx = -py * 5;     // rotateX
        if (!raf) raf = requestAnimationFrame(apply);
      });
      stage.addEventListener('pointerleave', function () {
        rx = 0; ry = 0;
        if (!raf) raf = requestAnimationFrame(apply);
      });
    }
  }

  function boot() {
    var secs = document.querySelectorAll('[data-hb3d]');
    for (var i = 0; i < secs.length; i++) initSection(secs[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor: re-inicializa al recargar la sección */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-hb3d]');
    if (sec) { sec.dataset.hb3dInit = ''; initSection(sec); }
  });
}());
